<template>
  <div class="submit has-background-white-bis fixspace">
    <section class="hero is-medium" v-show="!isSubmitted">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">

            <div class="column">
              <i18n
                path="submit.pagetitle"
                tag="h1"
                class="has-text-black is-size-3-desktop is-size-4-mobile"
                style="font-weight: 900"
              >
                <template v-slot:br><br /></template>
              </i18n>
              <i18n path="submit.pageintro" tag="p" class="pt-5">
                <template v-slot:br><br /></template>
              </i18n>
            </div>

            <div class="column is-half">
              <h2
                class="has-text-weight-normal has-text-black
                is-size-4-desktop is-size-6-mobile pb-5"
              >
                {{ $t("submit.workinformation") }}
              </h2>

              <iframe
                id="hidden_iframe"
                name="hidden_iframe"
                v-on:load="hiddenResponseOnLoad"
                style=display:none
              >
              </iframe>

              <form ref="dataForm"
                    @submit="submitForm"
                    :action="googleFromEndPoint"
                    target="hidden_iframe"
              >
                <b-field
                  :label="$t('submit.url')"
                  :type="urlInputType || 'is-dark'"
                  :message="urlInputMessage"
                >
                  <b-input
                    v-model="url"
                    required
                  >
                  </b-input>
                </b-field>
                <b-field :label="$t('submit.instruments')" type="is-dark">
                  <b-taginput
                    v-model="instruments"
                    field="trans"
                    autocomplete
                    :data="instrumentTags"
                    :allow-new="false"
                    :open-on-focus="true"
                    @typing="getFilteredInstrumentTags"
                    type="is-dark"
                  >
                  </b-taginput>
                </b-field>
                <b-field :label="$t('submit.genre')" type="is-dark">
                  <b-taginput
                    v-model="genre"
                    autocomplete
                    field="trans"
                    :data="genreTags"
                    :allow-new="false"
                    :open-on-focus="true"
                    attached
                  >
                  </b-taginput>
                </b-field>

                <input v-model="formUrl"
                       name="entry.539336625"
                       type="text"
                       v-show="false"/>
                <input v-model="formInstruments"
                       name="entry.1793895075"
                       type="text"
                       v-show="false"/>
                <input v-model="formGenre"
                       name="entry.1486343395"
                       type="text"
                       v-show="false"/>

                <button
                  :class="
                    [url ? 'is-black' : 'is-static'] +
                    ' button is-fullwidth mt-5 is-black'
                  "
                >
                  <span class="has-text-weight-semibold">
                    {{ $t("submit.post") }}
                  </span>
                </button>
              </form>
            </div>

          </div>
        </div>
      </div>
    </section>

    <section class="hero is-medium" v-show="isSubmitted">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1
            class="has-text-black is-size-1-desktop is-size-4-mobile"
            style="font-weight: 900"
          >
            {{ $t("submit.postmsgtitle") }}
          </h1>
          <p class="has-text-grey is-size-5-desktop is-size-6-mobile py-6">
            {{ $t("submit.postmsg") }}
          </p>
          <router-link to="/explore">
            <button class="button mx-1 px-5 is-black">
              <span class="has-text-weight-semibold">
                {{ $t("submit.postcomplete") }}
              </span>
            </button>
          </router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { getTags } from '@/api/api';

export default {
  name: 'Submit',

  metaInfo() {
    return {
      title: this.$t('title.submit'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.submit') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      allTags: [],
      instrumentTags: [],
      genreTags: [],
      filteredTags: [],

      url: '',
      urlInputType: '',
      urlInputMessage: '',
      instruments: [],
      genre: [],

      googleFromEndPoint: 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeUqQAz1Pzx0nrVXZFhgrqb7EM1UbvB3PIDRiHzSSfywQsjyA/formResponse',
      formUrl: '',
      formInstruments: '',
      formGenre: '',

      isSubmitted: false,
    };
  },

  computed: {},

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  mounted() {
    this.fetchData();
    this.forGtag();
  },

  methods: {
    getFilteredInstrumentTags(text) {
      this.instrumentTags = this.allTags.filter((option) => option.trans
        .toString()
        .toLowerCase()
        .indexOf(text.toLowerCase()) >= 0
          && (option.type !== 'keyboard' && option.type !== 'composer'));
    },

    fetchData() {
      getTags(null, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const { data } = result.data;

          this.allTags = data;
          this.instrumentTags = data.filter((item) => (item.type !== 'genre' && item.type !== 'composer'));
          this.genreTags = data.filter((item) => item.type === 'genre');

          this.loading = false;
        })
        .catch((err) => { console.error(err); });
    },

    checkIsYoutubeLink(url) {
      const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

      return url.match(p) !== null;
    },

    submitForm(e) {
      this.formUrl = this.url;
      this.formInstruments = this.instruments.map((item) => item.name).join(',');
      this.formGenre = this.genre.map((item) => item.name).join(',');
      const isYoutubeLink = this.checkIsYoutubeLink(this.url);

      if (this.formUrl !== '' && isYoutubeLink) {
        this.isSubmitted = true;
        return true;
      }

      if (!isYoutubeLink) {
        this.urlInputType = 'is-danger';
        this.urlInputMessage = this.$t('submit.youtubeUrlErrorMessage');
      }

      e.preventDefault();
      return false;
    },

    hiddenResponseOnLoad() {
      if (this.isSubmitted) {
        console.debug('ok');
      }
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.submit'));
      }, 500);
    },
  },
};
</script>

<style lang="scss">
// .taginput-container.is-dark,
// .select.is-dark select {
//   border-radius: 0px !important;
// }
</style>
